export { Template } from "@thelabnyc/thelabui/src/templates/LabUIIncludeReactContextTemplate";
